import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import PageLoading from '../components/utils/PageLoading'
const PublicRoute = ({ component: Component, isAuthenticated, loading, ...rest }) => {
    return (
        <Route {...rest} render={props => {
            if (loading){
                return <PageLoading />
            }
            else{
                if (isAuthenticated){
                    return <Redirect to="" />
                }
                else{
                    return <Component {...props}/>
                }
            }
        }}/>
    )
}
const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.Authentication.loginStatus,
        loading: state.Authentication.loading,
    }
}
export default connect(mapStateToProps)(PublicRoute)
